import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/UseAuth';
import React, { useEffect } from 'react'; // Importamos useEffect
import { useLangNavigate } from '../../hooks/useLangNavigate';
import Spinner from '../layout/Spinner';

function GuestRoute() {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();
  const langNavigate = useLangNavigate();

  // --- INICIO DE LA CORRECCIÓN ---
  // El useEffect ahora está en el nivel superior del componente.
  useEffect(() => {
    // La condición se comprueba DENTRO del efecto.
    // También nos aseguramos de no redirigir mientras aún se está cargando el estado de autenticación.
    if (!loading && isAuthenticated && user) {
      let redirectTo = '/explore';
      if (user.profileType === 'creator') {
        redirectTo = '/dashboard';
      }

      const from = location.state?.from?.pathname || redirectTo;
      langNavigate(from, { replace: true });
    }
  }, [loading, isAuthenticated, user, location, langNavigate]); // Se añaden todas las dependencias
  // --- FIN DE LA CORRECCIÓN ---

  // Si está cargando O si está autenticado (y por lo tanto, a punto de ser redirigido),
  // mostramos un spinner para evitar cualquier parpadeo.
  if (loading || isAuthenticated) {
    return <Spinner fullScreen={true} />;
  }

  // Si no está cargando y no está autenticado, renderiza el contenido para invitados (Login, Register).
  return <Outlet />;
}

export default GuestRoute;
